import { createAction, createReducer } from 'redux-act'
import axios from 'axios'

// Default State
const defaultState = {
    katexCode: '',
    isSaving: false
}

// Action Creators
export const actions = {
    createNewShare: createAction('Creates a new share', (katexCode = '') => ({
        katexCode
    })),

    onCodeChange: createAction('Handles code change', katexCode => ({
        katexCode
    })),

    startSave: createAction('Start saving the share'),

    saveFinished: createAction('Indicates that saving the share has finished')
}

// Reducer
export default createReducer(
    {
        [actions.createNewShare]: (state, { katexCode }) => ({
            ...defaultState,
            katexCode
        }),

        [actions.onCodeChange]: (state, { katexCode }) => ({
            katexCode
        }),

        [actions.startSave]: state => ({
            ...state,
            isSaving: true
        }),

        [actions.saveFinished]: state => ({
            ...state,
            isSaving: false
        })
    },
    defaultState
)

// Selectors
export const canSave = ({ katexCode }) => {
    return katexCode && katexCode.length > 0
}

// Thunks
export const thunks = {
    createNewShare: (katexCode = '') => (dispatch, getState) => {
        const { newShare } = getState()

        // TODO(AM): Replace with something nicer.
        if (canSave(newShare)) {
            const confirmationResult = window.confirm(
                'You have unsaved changes, would you like to continue?'
            )

            if (!confirmationResult) return Promise.reject()
        }

        dispatch(actions.createNewShare(katexCode))
        return Promise.resolve()
    },

    saveShare: () => (dispatch, getState) => {
        dispatch(actions.startSave())

        const { newShare } = getState()
        const endpoint =
            'https://us-central1-mathbox-d6e8f.cloudfunctions.net/saveMath'
        const payload = { math: newShare.katexCode }

        return axios
            .post(endpoint, payload)
            .then(response => {
                dispatch(actions.createNewShare())
                return response.data
            })
            .catch(err => {
                dispatch(actions.saveFinished())
                throw err
            })
    }
}



// WEBPACK FOOTER //
// ./src/ducks/newShare.js